var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("" + _vm.skinClass)},[(!_vm.$store.state.app.denyDesktop)?_c('router-view'):_c('div',{staticClass:"pd-10 text-muted"},[_vm._v("Хандах боломжгүй !")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }